export function buildLifetimeSignupHref(utm = {}) {
  const params = new URLSearchParams({
    next: "/pricing",
    plan: "lifetime",
    utm_source: utm.utm_source || "homepage",
    utm_medium: utm.utm_medium || "landing_page",
    utm_campaign: utm.utm_campaign || "complete_vault_25",
  });
  if (utm.utm_content) params.set("utm_content", utm.utm_content);
  if (utm.utm_term) params.set("utm_term", utm.utm_term);
  return `/initiate?${params.toString()}`;
}